import {
  OffCanvasLayout,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import OrderCardListing from "../OrderCardListing";
import useRecheckStaffWindow from "./useRecheckStaffWindow";
import Style from "./staffWindow.module.scss";
import Filter from "./Filter";
import PendingTable from "./PendingTable";
import AssignedTable from "./AssignedTable";
import FilterButton from "../FilterButton";

const RecheckStaffWindow = () => {
  const {
    activeCard,
    apiStatus,
    staffState,
    isLoading,
    totalLength,
    filterCount,
    setIsLoading,
    handleFilter,
    handleCardClick,
    handleStartClick,
    handleSearch,
    handleSearchInput,
    handleLoadMore,
  } = useRecheckStaffWindow();

  return (
    <>
      <div className={Style.varifaication_main_wrap}>
        <div className="row">
          <div className={`col-xxl-4 col-5 cards-wrapper ${Style.card_main_wrapper}`}>
            <div className="row pro-mb-4 gx-2">
              <div className="col-auto">
                <div className="search-wrap">
                  <SearchFilters
                    showDateRange={false}
                    onSearchInput={handleSearchInput}
                    searchInputProps={{onKeyDown: (e) => e.key === 'Enter' && handleSearch(),placeholder:"Search GLI Number" }}
                    showFilters={true}
                    showActions={false}
                    SearchIcon={
                      <span className="material-symbols-outlined"> search </span>
                    }
                    className="search-input"
                  />
                </div>
              </div>
              <div className={`col-auto`}>
                <button
                  className="pro-btn pro-btn-primary "
                  type="button"
                  onClick={handleSearch}
                >
                  <span className="material-symbols-outlined">search</span>
                  Search
                </button>
              </div>
              <div className="col">
                <FilterButton
                  onClick={handleFilter}
                  filterCount={filterCount}
                  className={Style.filter_btn}
                />
              </div>
            </div>
            <div className={`pro-d-flex ${Style.card_flow_wrap}`}>
              <OrderCardListing
                data={staffState?.cardData}
                // lastElement={lastElement}
                handleChange={handleCardClick}
                hasButton={true}
                activeCard={activeCard}
                handleStartClick={handleStartClick}
                extaClassName={Style.card_listing}
                apiStatus={apiStatus}
                handleLoadMore={handleLoadMore}
                refBottom
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                totalLength={totalLength}

              />
            </div>
          </div>
          {staffState?.showTable && (
            <div className={`col ${Style.table_main_wrapper}`}>
              <h5 className="pro-ttl h5">{staffState?.gliData?.name}</h5>
              <h6 className="pro-ttl h6">{staffState?.gliData?.shop}</h6>
              {true ? (
                <>
                  <PendingTable />
                </>
              ) : (
                <div className="col">
                  <h5 className="pro-ttl h5">table is empty</h5>
                </div>
              )}
            </div>
          )}
          {staffState?.showAssignedTable && (
            <div className={`col ${Style.table_main_wrapper}`}>
              <h5 className="pro-ttl h5">{staffState?.gliData?.name}</h5>
              <h6 className="pro-ttl h6">{staffState?.gliData?.shop}</h6>
              {true ? (
                <>
                  <AssignedTable />
                </>
              ) : (
                <div className={`col ${Style.table_main_wrapper}`}>
                  <h5 className="pro-ttl h5">table is empty</h5>
                </div>
              )}
            </div>
          )}
          {!staffState?.showTable && !staffState?.showAssignedTable && (
            <div className={`col ${Style.table_main_wrapper}`}>
              {/* <h5 className="pro-ttl h5">Select one</h5> */}
            </div>
          )}
        </div>
        <OffCanvasLayout
          centered={true}
          show={staffState?.showFilter}
          handleClose={handleFilter}
          title={"Filter"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <Filter />
        </OffCanvasLayout>
      </div>
    </>
  );
};

export default RecheckStaffWindow;
